import React from "react"
import Loader from "../../ui/loader"
import { Button } from "../../ui/button"
import { SvgWarning } from "../../icons"

interface Props {
  setShowDeleteDialogueModal: (show: boolean) => void
  outOfOfficeRange: { from: Date; to: Date; meeting_id?: number | null }
  onDelete: () => void
  loading: boolean
}

const DeleteOutOfOfficeModal: React.FC<Props> = ({
  setShowDeleteDialogueModal,
  outOfOfficeRange,
  onDelete,
  loading,
}) => {
  return (
    <div
      className="fixed w-screen h-screen top-0 left-0 zoee-backdrop-filter 
            z-[9001] flex items-center justify-center"
    >
      <div
        className="px-[40px] md:px-[100px] py-[80px] max-h-[90vh] w-[90%] md:w-[800px] max-w-[95%] bg-white 
                        main-shadow rounded-[16px] flex flex-col items-center relative overflow-y-auto"
      >
        <SvgWarning className="w-12 h-12 text-red-600 mb-4" />
        <h1 className="text-black text-2xl font-semibold text-center mb-6">
          Confirm Delete Out of Office
        </h1>
        <p className="text-center text-lg mb-8">
          Are you sure you want to permanently delete your Out of Office from{" "}
          <strong>{outOfOfficeRange.from.toLocaleString()}</strong> to{" "}
          <strong>{outOfOfficeRange.to.toLocaleString()}</strong>?
        </p>
        <div className="flex gap-4 justify-center w-full">
          <Button
            onClick={() => setShowDeleteDialogueModal(false)}
            variant="secondary"
            className="flex-1"
            disabled={loading}
          >
            {loading ? <Loader /> : "Cancel"}
          </Button>
          <Button
            onClick={onDelete}
            variant="destructive"
            className="flex-1"
            disabled={loading}
          >
            {loading ? <Loader /> : "Confirm"}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DeleteOutOfOfficeModal
